export const FILTERS_MODAL_CTA_TEXT = (appliedFilterCount: number) =>
  `All filters${appliedFilterCount > 0 ? ` (${appliedFilterCount})` : ""}`;

export const CLEAR_FILTERS_MODAL_CTA_TEXT = "Clear All Filters";
export const APPLY_FILTERS_MODAL_CTA_TEXT = (filtersToApplyCount: number) =>
  `Apply Filters${filtersToApplyCount > 0 ? ` (${filtersToApplyCount})` : ""}`;
